import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {EligibilityCheckComponent} from './eligibility-check.component';
import {OptionsComponent} from './options/options.component';
import {EligibilityCheckService} from '../../service/eligibility-check.service';
import {CreditOptionsCategorizer} from './options/credit-options-categorizer';
import {OnlyPartnersOfferingEligibilityCheckGuard} from '../../guards/only-partners-offering-eligibility-check.guard';
import {AdvanceEmiOptionsComponent} from './advance-emi-options/advance-emi-options.component';

const routes: Routes = [{
    path: '',
    pathMatch: 'full',
    component: EligibilityCheckComponent,
    canActivate: [OnlyPartnersOfferingEligibilityCheckGuard]
}, {
    path: 'options',
    component: OptionsComponent
}, {
    path: 'advance-emi-options',
    component: AdvanceEmiOptionsComponent
}];

@NgModule({
    exports: [RouterModule],
    imports: [RouterModule.forChild(routes)],
    providers: [OnlyPartnersOfferingEligibilityCheckGuard, EligibilityCheckService, CreditOptionsCategorizer]
})
export class EligibilityCheckRoutingModule {
}
